/**
 * Ganzzahlfelder ohne Nachkommastellen — `built_year` (Gebäude), `floor`
 * (Einheit; negativ erlaubt, Spec 02a, „Reiter Stammdaten"). Anders als
 * `area.ts` keine Umrechnung zwischen Komma und Punkt, nur die Prüfung auf
 * eine reine Ganzzahl. Die eigentliche Wertebereichsprüfung bleibt beim
 * Server; ein ungültiger Wert kommt als Feldfehler zurück (`field:
 * built_year` / `field: floor`), nicht als Client-Validierung.
 */

const INTEGER = /^-?\d+$/

/** `"1972"` → `1972`, `""` → `null` (das Feld ist optional). `null` auch bei
 * allem, was keine reine Ganzzahl ist — Nachkommastellen eingeschlossen. */
export function parseIntegerInput(input: string): number | null {
  const trimmed = input.trim()
  if (trimmed === '') return null
  if (!INTEGER.test(trimmed)) return null

  return Number(trimmed)
}

/** `1972` → `"1972"`, fürs Vorbelegen eines Eingabefelds. */
export function integerToInputValue(value: number): string {
  return String(value)
}
